import type React from 'react';
import type { JSX } from 'react';

interface ParentSizeWrapperProps {
    children: React.ReactNode;
    isCompact: boolean;
    overlay?: React.ReactNode;
}

const ParentSizeWrapper = ({ children, overlay }: ParentSizeWrapperProps): JSX.Element => {
    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                width: '100%',
                minHeight: 0,
                position: 'relative',
                boxSizing: 'border-box',
            }}
        >
            {children}
            {overlay}
        </div>
    );
};

export default ParentSizeWrapper;
